import { render, staticRenderFns } from "./client-profile-lists.vue?vue&type=template&id=7a0b48f2"
import script from "./client-profile-lists.vue?vue&type=script&lang=js"
export * from "./client-profile-lists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports